module.exports = __webpack_public_path__ + "static/media/FR-01.db2861ed.geojson";